module.exports = __webpack_public_path__ + "img/3D.3277e868.svg";